import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Redirect } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import { mediaQuery } from 'dbrain-web-ui-lib'
// import { translate } from 'react-i18next'
import Header from '../Header'
import * as appActions from './actions'
import {
	Task,
	Main,
	Grid,
	Oops,
} from '../../components'
import config from '../../config'
import './style'

const isSmallScreen = document.body.offsetWidth <= 550

class App extends Component {
	componentDidMount() {
		window.addEventListener('resize', this.handleResize.bind(this))
	}

	setDeviceType() {
		const isMobile = mediaQuery.is(mediaQuery.xs)

		if (this.props.app.isMobile !== isMobile) {
			this.props.actions.setIsMobile(isMobile)
		}
	}

	handleResize() {
		this.setDeviceType()
	}

	render() {
		const {
			actions,
		} = this.props

		const { routes } = config

		return (
			<React.Fragment>
				<Header actions={actions} />
				<div className="container-wrapper">
					<div className="container">
						<div className="container-inner">
							<Switch>
								<LocalRoute exact path={routes.index} component={Main} {...this.props} />

								{
									Object.keys(routes.demo).map(item => (
										<LocalRoute
											key={item}
											component={Task}
											{...routes.demo[item]}
										/>
									))
								}

								<Route path="*" render={() => <Redirect to={routes.index} />} />
							</Switch>
						</div>
					</div>
				</div>

				<Grid />
			</React.Fragment>
		)
	}
}

// eslint-disable-next-line
const LocalRoute = ({ component: Component, ...rest }) => (
	isSmallScreen
		? (<Route component={Oops} />)
		: (
			<Route
				{...rest}
				render={props => (<Component {...props} {...rest} />)}
			/>
		)
)

App.propTypes = {
	actions: PropTypes.object.isRequired,
	app: PropTypes.object.isRequired,
}

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(
		Object.assign({}, appActions),
		dispatch,
	),
})
export default connect(state => state, mapDispatchToProps)(App)
